/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import MainDetail from './MainDetails/MainDetail';
import SubDetail from './SubDetails/SubDetail';
import { useMetadataContext } from '../MetadataContext';

export default function MetadataDetail() {
    const UIContext = useMetadataContext();
    const UIProps = useMemo(() => {
        return {
            isSubMain: UIContext.isSubMain,
        };
    }, [UIContext]);
    const { isSubMain } = UIProps;

    return (
        <>
            {
                isSubMain ? <SubDetail /> : <MainDetail />
            }
            {/* <MainDetail />
            <SubDetail /> */}
        </>
    );
}
